export default {
  commercial: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  historicalSenders: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  historicalConversations: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  googleStoreToken: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  historicalConversation: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  sendWhatsappMessage: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  permissions: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  statusPermissions: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  integrateWithCalendar: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  statusAllSdr: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  settings: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  internalVariables: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  excelVariables: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  // {{NEXT}}
}
